import { MESSAGES } from '@guuru/chat-common';
import { appendLocalMessage, ChatAPI } from '@guuru/chat-web';
import events from '@guuru/events-web';
import { delay as sleep } from '@guuru/helpers-common';

const requestEmail = 'bot:::requestEmail';

const addBotRequestEmailMessage = () =>
  sleep(ChatAPI.getBotEllipsisMessageDelay()).then(() => {
    const message = ChatAPI.messages.createBotMessage(
      Date.now(),
      requestEmail,
      MESSAGES.message,
      {},
      true,
      false,
    );
    ChatAPI.pushPendingMessages(message);
    return message;
  });

const addedEmail = (partnerId, email) => {
  const message = ChatAPI.messages.createAnonymousTextMessage(
    email,
    true,
    false,
  );
  ChatAPI.storeEmail(email);
  ChatAPI.pushPendingMessages(message);
  return message;
};

export default {
  validate() {
    return !ChatAPI.storeRetrieveEmail();
  },

  async render() {
    const message = await addBotRequestEmailMessage();
    events.requestEmail();
    appendLocalMessage(message);
  },

  processResponse(partnerId, { text }) {
    const addedEmailMessage = addedEmail(partnerId, text);
    events.emailSubmitted(text);
    appendLocalMessage(addedEmailMessage);
  },
};
